export default __webpack_public_path__ + "fdbfeefe42f66a1f792bf3ba47cec411.png";